<template>
    <div class="box">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="tab-box">
                <div class="txt">当前门店：{{ data.storeName }}</div>
                <div class="txt">数据统计时段：{{ data.dateTime }}</div>
                <div class="title-tab-box">
                    <van-tabs animated v-model="activeName" @change="clickTypeTab">
                        <van-tab title="权益金" name="recharge"> </van-tab>
                        <van-tab title="净消费" name="consume"> </van-tab>
                    </van-tabs>
                </div>
                <div class="head-chart" v-if="activeName == 'consume'">
                    <div ref="headchart" id="headchart"></div>
                </div>
                <div class="inner-box">
                    <div class="search">
                        <form action="/">
                            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                            </van-search>
                        </form>
                    </div>
                    <div class="table-tab  flex flex-x-center flex-between">
                        <div :class="`tab-item ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">
                            已贡献客户({{ data.fulfill }})
                        </div>
                        <div :class="`tab-item item-text ${tabIndex == 2 ? 'active' : ''}`" @click="clickTab(2)">
                            未贡献会员({{ data.notFulfill }})
                        </div>
                    </div>
                    <div class="box-line"></div>
                    <div class="list-box" v-if="dataList.length > 0">
                        <div class="flex-y-center flex-start"><img class="list-tit-icon" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/equity-all.png" />
                            <div class="list-tit">{{ activeName == 'recharge' ? '权益金' : '净消费' }}总额：{{ data.amtSum }}万元</div>
                        </div>
                        <div class="select-box flex flex-y-center flex-start" v-if="activeName != 'recharge'">
                            <div class="select-item mr-50 flex-between flex-y-center" @click="selectTypePopup">
                                <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                                <van-icon name="play" class="select-arrow" />
                            </div>
                        </div>
                        <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getList" :offset="20" :immediate-check="false">
                            <div class="customer-list flex-col" v-for="(item, index) in dataList" :key="index" @click="toDetail(item.custId, item.phone)">
                                <div v-if="activeName == 'recharge'" class="customer-list-box flex-col ">
                                    <div class="customer-outer flex-row">
                                        <div class="customer-group flex-col  flex-1">
                                            <div class="customer-info flex-row">
                                                <img class="head-portrait" referrerpolicy="no-referrer" alt="" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                                                <div class="customer-info-box flex-col">
                                                    <div class="customer-main flex-row">
                                                        <span class="name" v-html="item.custName"></span>
                                                        <div class="card-grade flex-col">
                                                            <img class="card-image" v-if="item.levelCodeImg" alt="" referrerpolicy="no-referrer" :src="item.levelCodeImg" />
                                                        </div>
                                                    </div>
                                                    <span class="mobile" v-html="item.mobile"></span>
                                                </div>
                                            </div>
                                            <span class="card-balance">权益金：{{ item.saleAmt }}万元</span>
                                            <span class="arrived-store">净消费：{{ item.netAmt }}万元</span>
                                            <span class="arrived-store">专属顾问：{{ item.empName }}</span>
                                            <span class="arrived-store">最近来店：{{ item.latelyTime }}</span>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="activeName == 'consume'" class="customer-list-box consume flex-col ">
                                    <div class="customer-outer flex-row">
                                        <div class="customer-group flex-col  flex-1">
                                            <div class="customer-info flex-row">
                                                <img class="head-portrait consume" referrerpolicy="no-referrer" alt="" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                                                <div class="customer-info-box flex-col">
                                                    <div class="customer-main flex-row">
                                                        <span class="name" v-html="item.custName"></span>
                                                        <div class="card-grade flex-col">
                                                            <img class="card-image" v-if="item.levelCodeImg" alt="" referrerpolicy="no-referrer" :src="item.levelCodeImg" />
                                                        </div>
                                                    </div>
                                                    <span class="mobile" v-html="item.mobile"></span>
                                                </div>
                                            </div>
                                            <div class="statistics-list flex-y-center">
                                                <div class="v3-box flex-col flex-1">
                                                    <span class="v3-name">权益金</span>
                                                    <span class="v3-data">{{ item.accountAmt }}</span>
                                                </div>
                                                <div class="split-line"></div>
                                                <div class="v3-box flex-col flex-1">
                                                    <span class="v3-name">产品</span>
                                                    <span class="v3-data">{{ item.productAmt }}</span>
                                                </div>
                                                <div class="split-line"></div>
                                                <div class="v3-box flex-col flex-1">
                                                    <span class="v3-name">护理</span>
                                                    <span class="v3-data">{{ item.nurseAmt }}</span>
                                                </div>
                                                <div class="split-line"></div>
                                                <div class="v3-box flex-col flex-1">
                                                    <span class="v3-name">医美</span>
                                                    <span class="v3-data">{{ item.doctorAmt }}</span>
                                                </div>
                                                <div class="split-line"></div>
                                                <div class="v3-box flex-col flex-1">
                                                    <span class="v3-name">抗衰</span>
                                                    <span class="v3-data">{{ item.declineAmt }}</span>
                                                </div>
                                            </div>
                                            <span class="arrived-store consume">专属顾问：{{ item.empName }}</span>
                                            <span class="arrived-store consume">最近来店：{{ item.latelyTime }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </van-list>
                    </div>
                    <div class="data-list" v-else style="margin:80px auto">
                        <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" description="暂无数据" />
                    </div>
                </div>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup" get-container="#app">
            <picker title="全部净消费" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
        </van-popup>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { getCookie } from '@/utils'
    import { Toast } from 'vant'
    import Picker from '@/components/Picker';
    import { mapState } from 'vuex'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "customerContribution",
        components: {
            Picker
        },
        inject: ['reload'],
        data() {
            return {
                tabIndex: 1, // tab栏下标
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                data: {},
                dataList: [
                    // 数据
                ],
                activeName: "recharge", //tab 权益金recharge 净消费consume
                searchStr: '',
                custConsume: {},// 净消费饼图
                checkedType: {
                    id: 0,
                    name: '全部净消费'
                },//所选
                showTypePopup: false,// 选择弹窗
                typeList: [{
                    id: 0,
                    name: '全部净消费'
                }, {
                    id: 1,
                    name: '生美产品'
                }, {
                    id: 2,
                    name: '生美护理'
                }, {
                    id: 3,
                    name: '医美'
                }, {
                    id: 4,
                    name: '抗衰'
                },],
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            this.activeName = this.$route.query.tabType
            this.postId = getCookie('postId') || localStorage.getItem('postId');

            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        this.$router.replace({
                            name: "customerContributionRegionPage",
                            query: {
                                date: this.$route.query.date,
                                type: this.$route.query.type,
                                tabType: this.$route.query.tabType
                            }
                        });
                    }
                }
                this.getList()
            })
        },
        methods: {
            getList() {
                if (this.activeName == 'recharge') {
                    this.getRechargeList()
                } else if (this.activeName == 'consume') {
                    this.getConsumeList()
                    this.initPieChart()
                }
            },
            // 权益金列表数据
            getRechargeList() {
                let params = {
                    page: this.page,
                    searchStr: this.searchStr,
                    date: this.$route.query.date,
                    type: this.$route.query.type,
                    cbType: this.tabIndex,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: `/business/rechargeDetails`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.data = res.data
                        this.dataList = this.page == 1 ? res.data.custDetailsDTOS.list : this.dataList.concat(res.data.custDetailsDTOS.list);
                        this.page += 1;
                        this.total = res.data.custDetailsDTOS.total;
                        // 手动清除 Toast
                        Toast.clear();
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.dataList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 净消费列表数据
            getConsumeList() {
                let params = {
                    page: this.page,
                    searchStr: this.searchStr,
                    date: this.$route.query.date,
                    type: this.$route.query.type,
                    cbType: this.tabIndex,
                    projType: this.checkedType.id,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: `/business/consumeDetails`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.data = res.data
                        this.dataList = this.page == 1 ? res.data.custConsumeDetailsDTOS.list : this.dataList.concat(res.data.custConsumeDetailsDTOS.list);
                        this.page += 1;
                        this.total = res.data.custConsumeDetailsDTOS.total;
                        // 手动清除 Toast
                        Toast.clear();
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.dataList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            //查看类型切换
            clickTypeTab() {
                this.tabIndex = 1
                // 自定义加载图标
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                    loadingType: 'spinner',
                });
                this.getList();
            },
            // 查询
            onSearch(e) {
                this.searchStr = e
                this.onRefresh();
            },
            // 弹窗
            selectTypePopup() {
                this.showTypePopup = true
            },
            onTypeChange(data) {
                this.checkedType = data
                this.showTypePopup = false
                this.onRefresh()
            },
            // tab切换
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                this.onRefresh();
            },
            onRefresh() {
                this.page = 1
                this.finished = false;
                this.loading = true;
                this.dataList = [];
                this.refreshing = false;
                this.getList()
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh();
            },
            // 净消费饼图
            getCustConsume() {
                let params = {
                    date: this.$route.query.date,
                    type: this.$route.query.type,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: `/business/custConsume`,
                    method: "get",
                    params: params
                }).then((res) => {
                    this.custConsume = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            //资产饼图加载
            initPieChart() {
                const _this = this

                this.getCustConsume().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    let myEcharts = this.$echarts.init(this.$refs.headchart);
                    window.onresize = myEcharts.resize;
                    let options = {
                        series: [
                            {
                                type: 'pie',
                                radius: ['34%', '60%'],
                                // avoidLabelOverlap: false,  //备注隐藏
                                label: {
                                    show: true,
                                    // color: "#35434C",
                                    rich: {
                                        c: {
                                            padding: [6, 0, 0, 0],
                                            fontSize: window.innerWidth * 26 / 750,
                                            color: "#35434C",
                                            align: 'left',
                                        },
                                    },
                                },
                                labelLine:
                                {
                                    normal: {
                                        length: 20,
                                        length2: 16,
                                        lineStyle: {
                                            width: 2//设置线条粗细
                                        }
                                    }
                                },
                                data: [
                                    { value: this.custConsume.productSum, name: '{c|生美产品\n' + this.custConsume.productSum + '万}', itemStyle: { color: '#f56d41' } },
                                    { value: this.custConsume.nurseSum, name: '{c|生美护理\n' + this.custConsume.nurseSum + '万}', itemStyle: { color: '#a8bdfe' } },
                                    { value: this.custConsume.doctorSum, name: '{c|医美\n' + this.custConsume.declineSum + '万}', itemStyle: { color: '#f9b59f' } },
                                    { value: this.custConsume.declineSum, name: '{c|抗衰\n' + this.custConsume.doctorSum + '万}', itemStyle: { color: '#5778ff' } }
                                ]
                            }
                        ]
                    };
                    myEcharts.setOption(options);
                });

            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "customerContributionRegionPage",
                            query: {
                                date: this.$route.query.date,
                                type: this.$route.query.type,
                                tabType: this.$route.query.tabType
                            }
                        });
                    } else {
                        this.reload();
                    }
                })
            },
        }
    };
</script>

<style scoped lang="less">
    .box {
        height: 100%;
        overflow-y: auto;
    }

    .tab-box {
        width: 750px;
        // height: 314px;

        background: #f5f6f7;
        padding-top: 30px;

        .txt {
            color: #66757f;
            font-size: 26px;
            padding-left: 30px;
        }

        .txt:nth-child(1) {
            margin-bottom: 16px;
        }
    }

    .head-chart {
        height: 570px;
        background-color: #fff;
    }

    #headchart {
        height: 570px;
    }

    .inner-box {
        padding: 0 30px;
        background: #ffffff;

        .table-tab {
            width: 100%;
            height: 100%;
            display: flex;

            .tab-item {
                width: 250px;
                height: 42px;
                font-size: 30px;
                font-weight: 400;
                color: #a0acb5;
                text-align: center;
                position: relative;
            }

            .item-text {
                margin-left: 102px;
            }

            .tab-item.active {
                color: #35434c;
                font-weight: bold;
            }

            .tab-item.active::after {
                position: absolute;
                bottom: -20px;
                content: "";
                width: 110px;
                height: 4px;
                background: #37dbe0;
                left: 50%;
                transform: translateX(-50%);
            }
        }

        .box-line {
            width: 690px;
            height: 1px;
            background: #d7d7d7;
            margin: 20px 0 0 0;
            opacity: 0.5;
        }
    }

    .select-box {
        margin-bottom: 40px;
        margin-top: 20px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .title-tab-box {
        padding: 30px 90px 13px 90px;
        background: #f5f6f7;

        :deep(.van-tabs__line) {
            display: none;
        }

        :deep(.van-tab) {
            /* flex: none !important; */
            flex: 0 0 45% !important;
            // width: 250px;
            padding: 0 !important;
            height: 70px !important;
            line-height: 70px !important;
            color: #35434c;
            font-size: 30px;
        }

        :deep(.van-tab.van-tab--active) {
            /* width: 184rpx !important; */
            height: 70px !important;
            line-height: 70px;
            background: #2fd0d5 !important;
            border-radius: 35px !important;
            color: #fff !important;
        }
    }

    .list-box {
        width: 100%;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        padding: 30px 0 50px 0;

        .list-tit-icon {
            width: 40px;
            height: 40px;
        }

        .list-tit {
            color: #35434c;
            font-size: 34px;
            font-weight: 700;
            margin-left: 13px;
        }

        .customer-list {
            z-index: 35;
            min-height: 331px;
            border-radius: 30px;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
            width: 690px;
            position: relative;
            margin: 28px auto;

            .customer-list-box {
                width: 632px;
                min-height: 269px;
                margin: 30px 0 30px 30px;
            }

            .customer-list-box.consume {
                margin: 30px 0;
            }

            .customer-outer {
                width: 630px;
                min-height: 212px;
                margin-left: 2px;

                .statistics-list {
                    width: 690px;
                    background-color: rgba(250, 250, 254, 1);
                    border-radius: 30px;
                    height: 161px;
                    margin: 20px 0 10px 0;
                    padding: 39px 0;

                    .v3-box {
                        text-align: center;

                        .v3-name {
                            height: 37px;
                            font-size: 22px;
                            color: #a5b0b9;
                            margin-bottom: 17px;
                        }

                        .v3-data {
                            font-size: 26px;
                            font-weight: 700;
                            color: #35434c;
                        }
                    }

                    .split-line {
                        width: 2px;
                        height: 36px;
                        background: #e9e9e9;
                        border-radius: 2px;
                    }
                }

                .customer-group {
                    width: 325px;
                }

                .customer-info {
                    width: 320px;
                    height: 88px;
                }

                .head-portrait {
                    width: 88px;
                    height: 88px;
                    border-radius: 45px;
                }

                .head-portrait.consume {
                    margin-left: 30px;
                }

                .customer-info-box {
                    width: 212px;
                    height: 88px;
                    margin-left: 30px;
                }

                .customer-main {
                    width: 400px;
                    height: 48px;
                }

                .name {
                    max-width: 260px;
                    height: 48px;
                    display: inline-block;
                    color: rgba(53, 67, 76, 1);
                    font-size: 34px;
                    line-height: 48px;
                    text-align: left;
                    overflow: hidden;
                    /*溢出的部分隐藏*/
                    white-space: nowrap;
                    /*文本不换行*/
                    text-overflow: ellipsis;
                    /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
                }

                .card-grade {
                    height: 34px;
                    border-radius: 17px;
                    margin-top: 6px;
                    margin-left: 20px;
                }

                .txt3 {
                    width: 66px;
                    height: 30px;
                    display: inline-block;
                    color: rgba(255, 255, 255, 1);
                    font-size: 22px;
                    white-space: nowrap;
                    line-height: 30px;
                    text-align: left;
                    margin: 2px 0 0 12px;
                }

                .card-image {
                    height: 34px;
                    width: 90px;
                }

                .mobile {
                    width: 147px;
                    height: 37px;
                    display: inline-block;
                    color: rgba(53, 67, 76, 1);
                    font-size: 26px;
                    white-space: nowrap;
                    line-height: 37px;
                    text-align: left;
                    margin-top: 6px;
                }

                .membership-box {
                    width: 325px;
                    height: 37px;
                    margin-top: 30px;
                }

                .membership-attributes {
                    width: 234px;
                    height: 37px;
                    display: inline-block;
                    color: rgba(121, 138, 148, 1);
                    font-size: 26px;
                    white-space: nowrap;
                    line-height: 37px;
                    text-align: left;
                }

                .membership-div {
                    padding: 0 5px;
                    margin-left: 30px;
                    width: 70px;
                    height: 34px;
                    border-radius: 23px;
                    border: 2px solid #2fd0d5;
                    color: rgba(47, 208, 213, 1);
                    font-size: 22px;
                    white-space: nowrap;
                    line-height: 34px;
                    text-align: center;
                }

                .card-balance {
                    width: 234px;
                    height: 37px;
                    display: inline-block;
                    color: rgba(121, 138, 148, 1);
                    font-size: 26px;
                    white-space: nowrap;
                    line-height: 37px;
                    text-align: left;
                    margin-top: 20px;
                }
            }

            .arrived-store {
                width: 579px;
                height: 37px;
                display: inline-block;
                color: rgba(121, 138, 148, 1);
                font-size: 26px;
                white-space: nowrap;
                line-height: 37px;
                text-align: left;
                margin-top: 20px;
            }

            .arrived-store.consume {
                margin-left: 30px;
            }
        }
    }

    .store-box {
        padding: 30px 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.van-dropdown-menu__bar) {
        background-color: #f5f6f7 !important;
        height: 80px !important;
        box-shadow: none !important;
    }

    :deep(.van-dropdown-menu__title) {
        color: #35434c !important;
        font-size: 30px !important;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
        border-top-width: 7px !important;
        border-right-width: 7px !important;
        border-bottom-width: 7px !important;
        border-left-width: 7px !important;
        border-top-style: solid !important;
        border-right-style: solid !important;
        border-bottom-style: solid !important;
        border-left-style: solid !important;
    }

    :deep(.search .van-search) {
        background-color: #fff !important;
        padding: 30px 0 30px 0 !important;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 8px 20px 0 20px !important;
        margin-right: 0 !important;
    }

    :deep(.van-tabs__nav) {
        display: flex;
        justify-content: space-between;
        background-color: #f5f6f7 !important;
    }

    :deep(.van-list__finished-text) {
        height: 100px !important;
    }

    :deep(.van-icon) {
        font-size: 28px;
    }

    :deep(.van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-tab--active) {
        font-weight: 400 !important;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>
